import Vue from 'vue'

Vue.prototype.$echarts = null

if (process.client) {
  const echarts = require('echarts')
  Vue.prototype.$echarts = echarts
}